import { Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { createAnimation } from '@ionic/core';

import { AOContainerDirective } from './ao-container.directive';
import { AOContainerInterface } from './ao-container.interface';

@Component({
  selector: 'ao-container',
  templateUrl: './ao-container.component.html',
  styleUrls: ['./ao-container.component.scss']
})
export class AOContainerComponent implements OnInit, AOContainerInterface {

  @Input() directive: AOContainerDirective;

  @ViewChild("tref", {read: ElementRef, static: true}) tref: ElementRef;

  constructor(
    private _content: ViewContainerRef,
  ) {
  }

  ngOnInit() {
    const animation = createAnimation()
      // .addElement(document.querySelector('section'))
      .addElement(this.tref.nativeElement.innerHTML)
      // .addElement(this.tref.)
      .easing("ease-in-out")
      .duration(1000)
      .direction("alternate")
      .iterations(Infinity)
      .fromTo('opacity', '0.0', '0.8')
      .keyframes([
        { offset: 0, transform: "scale(1)", opacity: "1" },
        { offset: 1, transform: "scale(1.5)", opacity: "0.5" }
      ]);

    animation.play();
  }

  close() {
    this.directive.clear();
  }

}
